import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDownIcon, WalletIcon, HandshakeIcon, UsersIcon } from 'lucide-react';
const problems = [{
  icon: TrendingDownIcon,
  title: 'Stagnant Viewership',
  description: 'Algorithm changes buried your reach. You stream consistently but numbers flatline.'
}, {
  icon: WalletIcon,
  title: 'Monetization Blind Spots',
  description: "You're leaving €thousands on the table with misaligned revenue streams."
}, {
  icon: HandshakeIcon,
  title: 'Brand Deal Confusion',
  description: 'Sponsors lowball you because you lack negotiation frameworks and rate cards.'
}, {
  icon: UsersIcon,
  title: 'Audience Drift',
  description: "Your community engagement is declining. Viewers watch but don't subscribe or donate."
}];
export function Problems() {
  return <section className="py-24 relative z-10 bg-studio-900 border-t border-white/5" data-id="element-123">
      <div className="max-w-7xl mx-auto px-6" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-126">
            What's Holding Your Channel Back?
          </h2>
          <p className="text-gray-400 font-mono text-sm uppercase tracking-widest" data-id="element-127">
            System Diagnostics
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-128">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="glass-panel monitor-frame p-8 rounded-xl group hover:border-stream-500/30 transition-colors" data-id="element-129">
              <div className="flex items-start justify-between mb-6" data-id="element-130">
                <div className="w-12 h-12 rounded-lg bg-studio-800 border border-white/10 flex items-center justify-center text-stream-400 group-hover:scale-110 transition-transform" data-id="element-131">
                  <problem.icon className="w-6 h-6" data-id="element-132" />
                </div>
                <div className="flex items-center gap-2" data-id="element-133">
                  <div className="w-2 h-2 rounded-full bg-red-500/50" data-id="element-134" />
                  <span className="font-mono text-[10px] text-gray-500 uppercase" data-id="element-135">
                    ERR_DETECTED
                  </span>
                </div>
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-136">
                {problem.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-137">
                {problem.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}